import Image from "next/image"

/** Convert a flag emoji (e.g. "🇰🇭") to a lowercase ISO country code ("kh") */
export function flagEmojiToCode(emoji: string): string {
  const points = [...emoji].map(c => c.codePointAt(0) ?? 0)
  if (points.length < 2) return ""
  return points.map(p => String.fromCharCode(p - 0x1F1E6 + 65)).join("").toLowerCase()
}

export function FlagImage({ emoji, size = 24 }: { emoji: string; size?: number }) {
  // Accept plain ISO-3166 codes ("GB", "KH") as well as emoji flags ("🇬🇧", "🇰🇭")
  const code = emoji.length === 2 && /^[A-Za-z]{2}$/.test(emoji)
    ? emoji.toLowerCase()
    : flagEmojiToCode(emoji)
  if (!code || code.length !== 2) {
    return <span style={{ fontSize: size }}>{emoji}</span>
  }
  return (
    <span
      style={{ width: size, height: size, display: "inline-flex", flexShrink: 0 }}
      className="rounded-full overflow-hidden"
    >
      <Image
        src={`https://flagcdn.com/w40/${code}.png`}
        alt={code.toUpperCase()}
        width={size}
        height={size}
        className="w-full h-full object-cover"
        unoptimized
      />
    </span>
  )
}
